import { Controller } from "@hotwired/stimulus"
import { startIcons } from "../import_lucid.js"

export default class extends Controller {
  static targets = ["drawer", "overlay", "content"]
  static values = { url: String, loaded: Boolean }

  toggle() {
    if (this.drawerTarget.classList.contains("translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  connect() {
    startIcons(this.element)
  }

  open() {
    this.drawerTarget.classList.remove("translate-x-full")
    this.overlayTarget.classList.remove("hidden")
    if (!this.loadedValue) {
      this.loadPanel()
    }
  }

  close() {
    this.drawerTarget.classList.add("translate-x-full")
    this.overlayTarget.classList.add("hidden")
  }

  async loadPanel() {
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "text/html"
        }
      })
      if (response.ok) {
        const html = await response.text()
        this.contentTarget.innerHTML = html
        this.loadedValue = true
        startIcons(this.contentTarget)
      }
    } catch (error) {
      this.contentTarget.innerHTML = '<div class="p-4 text-sm text-red-500">Failed to load chat. Please try again.</div>'
    }
  }
}
